import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { PageLinks } from '../../../chatbot-core/chatbot.service';
import { Message } from '../../../chatbot-core/message/message.model';
import { CommonModule } from '@angular/common';
import { MarkdownPipe } from '../../../shared/pipes/markdown.pipe';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';
import { MathJaxConfigService } from '../../../shared/latex/mathjax-config.service';
import { CopyToInputDirective } from '../../../shared/directives/copy-to-input.directive';
import { HighlightMathSelectionDirective } from '../../../shared/directives/highlight-math-selection.directive';

@Component({
    selector: 'sabis-chatbot-bot-message',
    imports: [CommonModule, MarkdownPipe, SafeHtmlPipe, CopyToInputDirective, HighlightMathSelectionDirective],
    templateUrl: './bot-message.component.html',
    styleUrl: './bot-message.component.scss'
})
export class SabisChatbotBotMessageComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public message!: Message;
  @Output('regenerate') onRegeneraeMessage: EventEmitter<Message> = new EventEmitter();
  @ViewChild('messageContent', { read: ElementRef }) messageContentRef?: ElementRef<HTMLElement>;

  @Output() contentClick = new EventEmitter<{href: string, category: string | null}>()


  public displayedContent = '';
  public isBlinking = false;

  private _currentPromise: Promise<void> | null = null;

  constructor(
    private _mathjaxConfService: MathJaxConfigService
  ) {
  }

  ngOnInit(): void {
    this.displayedContent = this.message.content;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] && changes['message'].currentValue) {
      this.displayedContent = changes['message'].currentValue.content;
      if (this.messageContentRef?.nativeElement) {
        if (this._currentPromise) {
          this._currentPromise!.then(() => this._mathjaxConfService.typeset(this.messageContentRef?.nativeElement));
        }
        else {
          this._currentPromise = this._mathjaxConfService.typeset(this.messageContentRef!.nativeElement);
        }
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.displayedContent && this.displayedContent !== 'Typing...') {
      setTimeout(() => {
        this._mathjaxConfService.typesetClear(this.messageContentRef!.nativeElement).then(x => {
          this._mathjaxConfService.typeset(this.messageContentRef!.nativeElement);
        });
      }, 0);
    }
  }

  public regenerateResponse(message: Message): void {
    this.isBlinking = true;
    this.onRegeneraeMessage.emit(message);
    setTimeout(() => {
      this.isBlinking = false;
    }, 1000);
  }

  /// Handles the click event on the content, specifically for anchor tags with sabis-category attribute.
  public onContentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a');

    if (anchor) {
      event.preventDefault();
      const href = anchor.getAttribute('href');
      const category = anchor.getAttribute('sabis-category');

      if (href && category === PageLinks.EbookPageLink) {
        this.contentClick.emit({ href, category });
      }
    }
  }
}
